import { h, Component, render } from "preact";
import { isMobile } from "./util";
import { submit } from "./lib/Cart";
import Table from "./goods/Table";

jQuery(($) => {
  $(".spec-table").each((i, table) => {
    const $table = $(table);
    $table.wrap(`<div class="spec-table-wrap">`);

    const $wrap = $table.parent();

    function setScrollClass() {
      $wrap.removeClass("spec-table-wrap--scroll");
      setTimeout(() => {
        if ($table.width() - $wrap.width() > 1) {
          $wrap.addClass("spec-table-wrap--scroll");
        }
      }, 0);
    }
    $(window)
      .on("resize.om.spec-table", setScrollClass)
      .triggerHandler("resize.om.spec-table");
  });
});

jQuery(($) => {
  function setScrollClass() {
    $(".goods-item-table-wrap").each((i, wrap) => {
      const $wrap = $(wrap);
      $wrap.removeClass("goods-item-table-wrap--scroll");
      setTimeout(() => {
        if ($($wrap.find("table")).width() - $wrap.width() > 1) {
          $wrap.addClass("goods-item-table-wrap--scroll");
        }
      }, 0);
    });
  }
  $(window).on("resize.om.goods-item-table", setScrollClass);

  function resizeContainerFluid() {
    const $table = $("#goods-form-table table");
    const $container = $table.closest(".container-fluid");

    if ($table.width() > 725) {
      $container.removeClass("container-fluid-narrow");
      $(window).off("resize.om.goods-item-table", resizeContainerFluid);
    }
  }
  $(window).on("resize.om.goods-item-table", resizeContainerFluid);
});

jQuery(($) => {
  const table = document.getElementById("goods-form-table");
  if (!table) {
    [...document.querySelectorAll(".goods-form-table")].forEach((t) => {
      t.addEventListener(submit);
    });

    $.get(location.pathname + "/recommend")
      .then(function (res) {
        $("#recentries-recommend").html(res);
      })
      .then(function () {
        if (!navigator.userAgent.match(/Macintosh|iPhone|iPad|iOS/i)) {
          FONTPLUS.reload(false);
        }
      });

    return;
  }

  function renderTable(goods) {
    if (location.hash) {
      const id = location.hash.substr(1);
      const filteredGoods = [];
      goods.items.forEach((g) => {
        if (g[1] === id) {
          filteredGoods.push(g);
        }
      });
      if (filteredGoods.length > 0) {
        goods.items = filteredGoods;
      }
    }

    render(
      <Table
        perPage={10}
        addFavorites={table.dataset.addFavorites}
        goods={goods}
        type={isMobile() ? "sm" : "md"}
      />,
      table
    );
  }

  if (table.dataset.goods) {
    renderTable(JSON.parse(table.dataset.goods));
    return;
  }

  const itemsDfd = $.ajax({
    url: location.pathname + ".json",
    method: "GET",
    dataType: "json",
  }).then(renderTable);

  const recommendDfd = $.get(location.pathname + "/recommend").then(function (
    res
  ) {
    $("#recentries-recommend").html(res);
  });

  $.when(itemsDfd, recommendDfd).then(function () {
    if (!navigator.userAgent.match(/Macintosh|iPhone|iPad|iOS/i)) {
      FONTPLUS.reload(false);
    }
  });
});
